import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { AES } from "crypto-js";
import { Subject } from "rxjs";
import { ParametrosGeraisService } from "../parametros-gerais/parametros-gerais.service";
import { SessionService } from "../session/session.service";
@Injectable()
export class RedirecionamentoMatriculaService {
  protected privateKeyNonce: string = "token_univali";

  constructor(
    private SessionService: SessionService,
    private ParametrosGeraisService: ParametrosGeraisService
  ) {}

  getTokenCriptografado() {
    const token = encodeURIComponent(
      AES.encrypt(
        this.SessionService.getValor("token"),
        this.privateKeyNonce
      ).toString()
    );

    return token;
  }

  async criarLinkMatriculaComToken() {
    var subject = new Subject<string>();
    (await this.ParametrosGeraisService.getMatriculaOnlineUrl()).subscribe(
      (matriculaOnlineUrl) =>
        subject.next(
          `${matriculaOnlineUrl}/token?key=${this.getTokenCriptografado()}`
        )
    );
    return subject.asObservable();
  }

  async redirecionar() {
    (await this.criarLinkMatriculaComToken()).subscribe((url) => {
      window.location.href = url;
      return;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/redirecionamento-matricula/redirecionamento-matricula.service.ts